import { colors } from "@/app/Colors";

/* <------- Arrow-Right-01 -------> */
export const ArrowRight01Icon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.00005 6L15 12L9 18"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeMiterlimit="16"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <------- Mail-02 -------> */
export const Mail02Icon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    className={props.className}
    color={props.color}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 3C2.23122 3 1 4.23122 1 5.75V17.75C1 19.2688 2.23122 20.5 3.75 20.5H19.75C21.2688 20.5 22.5 19.2688 22.5 17.75V5.75C22.5 4.23122 21.2688 3 19.75 3H3.75ZM6.12803 7.10229C5.77024 6.89358 5.311 7.01443 5.10229 7.37222C4.89358 7.73001 5.01443 8.18925 5.37222 8.39796L10.3645 11.3101C11.2207 11.8096 12.2795 11.8096 13.1358 11.3101L18.128 8.39796C18.4858 8.18925 18.6067 7.73001 18.398 7.37222C18.1892 7.01443 17.73 6.89358 17.3722 7.10229L12.38 10.0144C11.9908 10.2415 11.5095 10.2415 11.1203 10.0144L6.12803 7.10229Z"
      fill={props.color}
    />
  </svg>
);

/* <------- Arrow-Left-01 -------> */
export const ArrowLeft01FillIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.287 5.30711C15.5672 5.42319 15.75 5.69667 15.75 6.00002L15.75 18C15.75 18.3034 15.5673 18.5768 15.287 18.6929C15.0068 18.809 14.6842 18.7449 14.4697 18.5304L8.46967 12.5305C8.17678 12.2376 8.17677 11.7627 8.46966 11.4698L14.4696 5.4697C14.6841 5.2552 15.0067 5.19103 15.287 5.30711Z"
      fill={props.color}
    />
  </svg>
);

/* <------- Arrow-Right-01 -------> */
export const ArrowRight01FillIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71304 5.30711C8.99329 5.19103 9.31588 5.25519 9.53038 5.46969L15.5303 11.4697C15.8232 11.7626 15.8232 12.2375 15.5303 12.5304L9.53033 18.5304C9.31583 18.7449 8.99324 18.809 8.71299 18.6929C8.43273 18.5768 8.25 18.3034 8.25 18L8.25005 6.00002C8.25005 5.69667 8.43278 5.4232 8.71304 5.30711Z"
      fill={props.color}
    />
  </svg>
);

export const AeroIcon = (props) => (
  <svg
    width={14}
    height={14}
    className={props.className}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={props.color}
    {...props}
  >
    <g clipPath="url(#clip0_214_17)">
      <path
        d="M1.76568 10.8907C1.80202 10.8455 1.84223 10.8035 1.88585 10.7652L9.22568 4.15643L8.99861 4.22609C8.7755 4.2929 8.54244 4.32029 8.30992 4.30703L4.39837 4.10203C3.89429 4.08734 3.47391 3.71207 3.40233 3.21289C3.34655 2.66249 3.74749 2.17108 4.29791 2.11528C4.34238 2.11077 4.38712 2.10925 4.4318 2.11072L11.5051 2.48142C12.0576 2.51006 12.4823 2.98116 12.4536 3.53364L12.4535 3.53475L12.0829 10.6081C12.0531 11.1605 11.5812 11.5842 11.0288 11.5545C10.9853 11.5522 10.942 11.547 10.8992 11.539C10.4103 11.4157 10.081 10.9584 10.1191 10.4555L10.317 6.54359C10.3278 6.33592 10.3708 6.13119 10.4445 5.93675L10.5774 5.63518L3.26734 12.2172C2.89978 12.5737 2.32697 12.6085 1.91897 12.299C1.48777 11.9524 1.41914 11.3219 1.76568 10.8907Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_214_17">
        <rect
          width={14}
          height={14}
          fill="white"
          transform="matrix(1 0 0 -1 0 14.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

/* <------- Folder-02 -------> */
export const Folder02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    fill={"none"}
    {...props}
  >
    <path
      d="M2 19V7.54902C2 6.10516 2 5.38322 2.24332 4.81647C2.5467 4.10985 3.10985 3.5467 3.81647 3.24332C4.38322 3 5.09805 3 6.54902 3H7.04311C7.64819 3 8.22075 3.27394 8.60041 3.74509L10.4175 6M10.4175 6H16C17.4001 6 18.1002 6 18.635 6.27248C19.1054 6.51217 19.4878 6.89462 19.7275 7.36502C20 7.8998 20 8.59987 20 10V11M10.4175 6H7"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.15802 15.5144L3.45643 14.7717C4.19029 12.9449 4.55723 12.0316 5.3224 11.5158C6.08757 11 7.07557 11 9.05157 11H17.1119C19.8004 11 21.1446 11 21.7422 11.8787C22.3397 12.7575 21.8405 14.0002 20.842 16.4856L20.5436 17.2283C19.8097 19.0551 19.4428 19.9684 18.6776 20.4842C17.9124 21 16.9244 21 14.9484 21H6.88812C4.19961 21 2.85535 21 2.25782 20.1213C1.66029 19.2425 2.15953 17.9998 3.15802 15.5144Z"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinejoin="round"
    />
  </svg>
);

export const DocIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    color={props.color}
    className={props.className}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z"></path>
  </svg>
);

/* <------- Arrow-Right-02 -------> */
export const ArrowRight02Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    className={props.className}
    onClick={props.onClick}
    {...props}
  >
    <path
      d="M15.0001 17L20 12L15 7"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 12H20"
      stroke={props.color}
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* <------- Cancel-01 -------> */
export const Cancel01Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={props.width}
    height={props.height}
    color={props.color}
    fill={"none"}
    className={props.className}
    onClick={props.onClick}
    {...props}
  >
    <path
      d="M19.0005 4.99988L5.00049 18.9999M5.00049 4.99988L19.0005 18.9999"
      stroke="currentColor"
      strokeWidth={props.strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AeroDown = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.00002 10.3026C7.91228 10.3031 7.82531 10.2862 7.74408 10.2531C7.66286 10.2199 7.58898 10.171 7.52669 10.1092L3.52669 6.10922C3.40115 5.98368 3.33063 5.81342 3.33063 5.63589C3.33063 5.45835 3.40115 5.28809 3.52669 5.16255C3.65222 5.03702 3.82249 4.96649 4.00002 4.96649C4.17756 4.96649 4.34782 5.03702 4.47336 5.16255L8.00002 8.69589L11.5267 5.16922C11.6542 5.06 11.8183 5.00293 11.9861 5.00941C12.1538 5.01589 12.313 5.08545 12.4317 5.20418C12.5505 5.32291 12.62 5.48207 12.6265 5.64985C12.633 5.81763 12.5759 5.98169 12.4667 6.10922L8.46669 10.1092C8.34251 10.2324 8.17492 10.3018 8.00002 10.3026Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayIcon = () => (
  <svg
    width={60}
    height={61}
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_123_598)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.4894 12.6414C55.2775 11.5463 53.743 10.8283 52.0646 10.6438C48.4164 10.2374 44.7353 10.0328 41.0417 9.93014C37.3722 9.8282 33.6868 9.8282 30.0096 9.83053C26.3329 9.8282 22.648 9.8282 18.9776 9.93014C15.2837 10.0328 11.6016 10.2374 7.95159 10.6438C6.2746 10.8283 4.74081 11.5466 3.53 12.6421C2.32716 13.7303 1.44332 15.1921 1.05659 16.8722C0.534622 19.1243 0.270709 21.4739 0.137347 23.8385C0.00328133 26.2126 0 28.5568 0 30.8328C0 33.1054 0 35.4469 0.13055 37.8224C0.260865 40.1858 0.521731 42.5354 1.04393 44.788C1.43277 46.4688 2.31732 47.931 3.51993 49.019C4.73003 50.1138 6.26241 50.8316 7.9387 51.0164C11.5894 51.4228 15.2715 51.6274 18.9654 51.7298C22.6355 51.8317 26.3207 51.8317 29.9979 51.8294C33.6767 51.8317 37.3619 51.8317 41.0316 51.7298C44.7247 51.6274 48.4059 51.4228 52.0559 51.0164C53.7322 50.8316 55.2643 50.1138 56.4747 49.0195C57.678 47.9315 58.5637 46.4692 58.9551 44.788C59.4752 42.5354 59.7359 40.1858 59.8666 37.8224C59.9955 35.4921 59.9965 33.1278 59.9965 30.8328H59.9988V30.7175H59.9965C59.9965 26.1571 59.9965 21.3274 58.9678 16.8722C58.5789 15.1911 57.6937 13.7294 56.4894 12.6414Z"
        fill="#E42B26"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.3836 29.7033C37.9652 27.9183 34.5702 26.1466 31.1789 24.3773C28.3598 22.9061 25.5435 21.4365 22.7187 19.9618L21.7864 19.4747V40.9906L22.7164 40.509C25.836 38.8929 28.9425 37.283 32.0485 35.6723L41.3811 30.8328L42.4674 30.2694L41.3836 29.7033Z"
        fill="#FFFFFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_123_598">
        <rect
          width={60}
          height={60}
          fill="white"
          transform="translate(0 0.829956)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const TeethIcon = ({ size = 18, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_1_111)">
      <path
        d="M17.9996 5.34786C17.9802 4.05615 17.4601 2.8414 16.5353 1.92737C15.6105 1.01348 14.3897 0.507657 13.0953 0.503052C11.6063 0.503052 10.4723 1.28071 9.48291 2.09911H9.47954C9.02261 2.09911 8.53936 1.82366 7.98202 1.50599C7.19814 1.05912 6.22266 0.503052 4.90473 0.503052C2.24055 0.503052 0.0405067 2.67645 0.000428607 5.3479C-0.0168331 6.4961 0.48889 9.02953 1.23019 11.5087C1.75835 13.275 2.84144 16.4382 4.16085 17.7776C4.6311 18.255 5.12312 18.497 5.62304 18.497C5.99186 18.497 6.3256 18.3437 6.58818 18.0538C6.76688 17.8564 6.91408 17.5939 7.03811 17.2513C7.23144 16.7175 7.35227 16.0386 7.4802 15.3198C7.80846 13.4756 8.12905 12.064 9.00173 12.0588C9.87445 12.064 10.195 13.4755 10.5233 15.3198C10.6512 16.0385 10.7721 16.7174 10.9654 17.2513C11.0894 17.5939 11.2366 17.8564 11.4153 18.0538C11.6749 18.3404 12.0039 18.4935 12.3677 18.497C12.3715 18.497 12.3751 18.497 12.3789 18.497H12.3805C12.3828 18.497 12.3853 18.497 12.3876 18.4969C12.8839 18.4936 13.3723 18.2515 13.8393 17.7775C15.1586 16.4382 16.2417 13.275 16.7698 11.5086C17.5112 9.02946 18.0168 6.49607 17.9996 5.34786ZM15.4229 11.1058C14.5878 13.8987 13.6456 15.9709 12.8378 16.7909C12.6631 16.9682 12.5238 17.0541 12.4343 17.0813C12.3902 17.0194 12.3044 16.8659 12.2058 16.5164C12.093 16.1171 12.0028 15.6101 11.9073 15.0733C11.7457 14.1658 11.5626 13.137 11.206 12.3236C10.6072 10.9576 9.69047 10.6593 9.0186 10.653C9.01463 10.653 9.01062 10.6529 9.00658 10.6529H8.99684C8.99284 10.6529 8.98883 10.653 8.98482 10.653C8.31298 10.6593 7.39625 10.9576 6.7974 12.3237C6.44081 13.137 6.25771 14.1657 6.09617 15.0733C6.00065 15.6101 5.91041 16.1171 5.79769 16.5164C5.69862 16.8675 5.61246 17.0208 5.56855 17.0821C5.47918 17.0559 5.3388 16.9701 5.16232 16.7909C4.3545 15.9709 3.41224 13.8988 2.5771 11.1059C1.79958 8.5057 1.39346 6.20944 1.40608 5.36899C1.43473 3.46103 3.00425 1.90881 4.9048 1.90881C5.85018 1.90881 6.58006 2.32488 7.28586 2.72714C7.57516 2.89206 7.86861 3.05937 8.17514 3.1963C7.48245 3.74084 6.81195 4.13374 6.02864 4.13374V5.53954C7.62273 5.53954 8.76892 4.55709 9.8774 3.60703C10.8964 2.73368 11.8588 1.90874 13.0928 1.90874C14.9948 1.91552 16.5655 3.46774 16.594 5.36892C16.6066 6.20937 16.2004 8.50563 15.4229 11.1058Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_111">
        <rect
          width={18}
          height={18}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DoctorIcon = (props) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_213_220)">
      <path
        d="M23.7386 4.29083C22.9714 3.26786 21.9766 2.43756 20.8329 1.86571C19.6892 1.29386 18.428 0.996146 17.1493 0.996157H16.8505C15.5718 0.996146 14.3107 1.29386 13.167 1.86571C12.0233 2.43757 11.0285 3.26786 10.2613 4.29083L10.261 4.29109C9.78748 4.92253 9.5315 5.6905 9.53146 6.47977V10.5984C9.53146 14.7232 12.8752 18.0669 17 18.0669C21.1247 18.0669 24.4684 14.7232 24.4684 10.5984V6.47977C24.4684 5.69049 24.2124 4.92251 23.7388 4.29109L23.7386 4.29083Z"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53146 9.53149H9.5316C10.2147 9.53146 10.8697 9.26013 11.3528 8.77719L12.7322 7.39767H12.7324C14.0574 8.06022 15.5185 8.40516 17 8.40516C18.4814 8.40516 19.9425 8.06022 21.2675 7.39767H21.2676L22.6471 8.77719C23.1302 9.26014 23.7852 9.53147 24.4683 9.53149H24.4684"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0038 33.0039L30.7582 26.267C30.4669 25.3931 29.9542 24.6095 29.2701 23.9925C28.586 23.3755 27.7538 22.9462 26.8545 22.7464L20.2007 21.2678L16.9999 26.6024L13.7992 21.2678L7.14536 22.7464C6.24609 22.9462 5.41389 23.3755 4.72979 23.9925C4.0457 24.6095 3.53302 25.3931 3.24168 26.267L0.996094 33.0039"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7992 21.2678V17.5129"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2007 21.2678V17.5129"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3346 33.0039H21.2677V29.8031C21.2677 29.3828 21.3505 28.9666 21.5113 28.5783C21.6722 28.1899 21.908 27.8371 22.2052 27.5399C22.5024 27.2427 22.8552 27.0069 23.2436 26.846C23.6319 26.6851 24.0481 26.6024 24.4684 26.6024C26.2362 26.6024 27.6692 28.0354 27.6692 29.8031V33.0039H26.6023"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.4684 25.5354V22.2161"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53147 28.7362C8.35376 28.7362 7.39764 29.6923 7.39764 30.87C7.39764 32.0477 8.35376 33.0039 9.53147 33.0039C10.7092 33.0039 11.6653 32.0477 11.6653 30.87C11.6653 29.6923 10.7092 28.7362 9.53147 28.7362ZM9.53147 28.7362V22.216"
        stroke={props?.color || "#131313"}
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_213_220">
        <rect width={34} height={34} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const PeopleIcon = (props) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3934 21.3995C27.8973 21.0816 28.3126 20.6414 28.6007 20.1199C28.8889 19.5984 29.0406 19.0125 29.0417 18.4167C29.0417 16.4639 27.4529 14.8751 25.5 14.8751C23.5471 14.8751 21.9583 16.4639 21.9583 18.4167C21.9583 19.6726 22.6206 20.7719 23.6095 21.4009C22.5921 21.6554 21.6809 22.2242 21.0056 23.0266C20.4213 22.6065 19.7621 22.3021 19.0634 22.1298C19.7255 21.7619 20.2774 21.2238 20.6618 20.5711C21.0462 19.9185 21.2493 19.1749 21.25 18.4174C21.25 16.0736 19.3439 14.1674 17 14.1674C14.6561 14.1674 12.75 16.0736 12.75 18.4174C12.7507 19.1749 12.9538 19.9185 13.3382 20.5711C13.7226 21.2238 14.2745 21.7619 14.9366 22.1298C14.2379 22.302 13.5786 22.6064 12.9944 23.0266C12.319 22.2244 11.4078 21.6555 10.3905 21.4009C10.8951 21.0832 11.3112 20.6429 11.5998 20.1212C11.8885 19.5994 12.0405 19.0131 12.0417 18.4167C12.0417 16.4639 10.4529 14.8751 8.5 14.8751C6.54713 14.8751 4.95834 16.4639 4.95834 18.4167C4.95834 19.6719 5.61921 20.7698 6.60663 21.3995C4.44409 21.9329 2.83334 23.8837 2.83334 26.2084V27.6251C2.83334 28.7967 3.78675 29.7501 4.95834 29.7501H10.625C10.625 30.9217 11.5784 31.8751 12.75 31.8751H21.25C22.4216 31.8751 23.375 30.9217 23.375 29.7501H29.0417C30.2133 29.7501 31.1667 28.7967 31.1667 27.6251V26.2084C31.1667 23.8837 29.5559 21.9322 27.3934 21.3995ZM25.5 16.2917C26.6716 16.2917 27.625 17.2452 27.625 18.4167C27.625 19.5883 26.6716 20.5417 25.5 20.5417C24.3284 20.5417 23.375 19.5883 23.375 18.4167C23.375 17.2452 24.3284 16.2917 25.5 16.2917ZM17 15.5834C18.5626 15.5834 19.8333 16.8542 19.8333 18.4167C19.8333 19.9793 18.5626 21.2501 17 21.2501C15.4374 21.2501 14.1667 19.9793 14.1667 18.4167C14.1667 16.8542 15.4374 15.5834 17 15.5834ZM8.5 16.2917C9.67159 16.2917 10.625 17.2452 10.625 18.4167C10.625 19.5883 9.67159 20.5417 8.5 20.5417C7.32842 20.5417 6.375 19.5883 6.375 18.4167C6.375 17.2452 7.32842 16.2917 8.5 16.2917ZM4.95834 28.3334C4.56734 28.3334 4.25 28.0154 4.25 27.6251V26.2084C4.25 24.2555 5.83879 22.6667 7.79167 22.6667H9.20834C10.2779 22.6667 11.2887 23.1626 11.9553 23.9849C11.0956 25.003 10.6243 26.2926 10.625 27.6251V28.3334H4.95834ZM21.9583 29.7501C21.9583 30.1404 21.641 30.4584 21.25 30.4584H12.75C12.359 30.4584 12.0417 30.1404 12.0417 29.7501V27.6251C12.0417 25.2812 13.9478 23.3751 16.2917 23.3751H17.7083C20.0522 23.3751 21.9583 25.2812 21.9583 27.6251V29.7501ZM29.75 27.6251C29.75 28.0154 29.4327 28.3334 29.0417 28.3334H23.375V27.6251C23.3757 26.2926 22.9044 25.003 22.0448 23.9849C22.3761 23.5752 22.7945 23.2443 23.2696 23.0162C23.7448 22.7882 24.2647 22.6689 24.7917 22.6667H26.2083C28.1612 22.6667 29.75 24.2555 29.75 26.2084V27.6251ZM23.8035 10.3672L23.7653 11.7634C23.7595 11.9865 23.8081 12.2076 23.9069 12.4078C24.0056 12.6079 24.1515 12.7811 24.3321 12.9123C24.5126 13.0434 24.7224 13.1288 24.9432 13.1609C25.1641 13.1929 25.3895 13.1708 25.5999 13.0964L26.916 12.6282L28.232 13.0964C28.4427 13.1708 28.6682 13.1929 28.8893 13.161C29.1104 13.129 29.3204 13.0439 29.5014 12.913C29.8683 12.6467 30.0787 12.2167 30.0666 11.7641L30.0284 10.3672L30.8805 9.2594C31.0168 9.08259 31.108 8.87518 31.1461 8.65517C31.1841 8.43516 31.168 8.20919 31.0989 7.99684C31.0299 7.78449 30.9102 7.59219 30.75 7.4366C30.5899 7.281 30.3942 7.16682 30.18 7.10395L28.8391 6.7087L28.0493 5.55624C27.9233 5.37169 27.7542 5.22067 27.5566 5.11629C27.359 5.0119 27.1389 4.95731 26.9154 4.95724C26.692 4.95717 26.4719 5.01163 26.2742 5.11589C26.0766 5.22014 25.9073 5.37106 25.7812 5.55553L24.9914 6.70799L23.6513 7.10324C23.437 7.16627 23.2414 7.28056 23.0813 7.4362C22.9212 7.59185 22.8014 7.78416 22.7324 7.99651C22.6633 8.20885 22.647 8.43483 22.685 8.65488C22.7229 8.87493 22.8139 9.08242 22.95 9.2594L23.8021 10.3665L23.8035 10.3672ZM25.6353 7.99574C25.7916 7.94963 25.9271 7.85107 26.0192 7.71665L26.8813 6.35665L27.8134 7.71665C27.9062 7.85053 28.0408 7.9497 28.1973 7.99574L29.7578 8.39595L28.752 9.70282C28.6528 9.83174 28.6011 9.99111 28.6053 10.154L28.7073 11.7619L27.154 11.2094C27.0005 11.1549 26.8329 11.1549 26.6794 11.2094L25.1827 11.803L25.2273 10.154C25.2316 9.99126 25.1799 9.83195 25.0807 9.70282L24.0536 8.46253L25.6353 7.99574ZM3.97021 10.3672L3.93196 11.7634C3.9262 11.9865 3.97479 12.2076 4.07353 12.4078C4.17228 12.6079 4.31821 12.7811 4.49876 12.9123C4.67931 13.0434 4.88905 13.1288 5.10991 13.1609C5.33077 13.1929 5.55613 13.1708 5.76654 13.0964L7.08263 12.6282L8.39871 13.0964C8.60935 13.1708 8.83488 13.1929 9.05596 13.161C9.27704 13.129 9.48707 13.0439 9.66804 12.913C10.035 12.6467 10.2453 12.2167 10.2333 11.7641L10.195 10.3672L11.0472 9.2594C11.1835 9.08259 11.2747 8.87518 11.3127 8.65517C11.3508 8.43516 11.3346 8.20919 11.2656 7.99684C11.1966 7.78449 11.0768 7.59219 10.9167 7.4366C10.7565 7.281 10.5609 7.16682 10.3466 7.10395L9.00575 6.7087L8.21596 5.55624C8.08995 5.37169 7.92082 5.22067 7.72323 5.11629C7.52564 5.0119 7.30557 4.95731 7.08211 4.95724C6.85864 4.95717 6.63853 5.01163 6.44088 5.11589C6.24323 5.22014 6.074 5.37106 5.94788 5.55553L5.15809 6.70799L3.81792 7.10324C3.60371 7.16627 3.40808 7.28056 3.24798 7.4362C3.08787 7.59185 2.9681 7.78416 2.89904 7.99651C2.82998 8.20885 2.81371 8.43483 2.85163 8.65488C2.88955 8.87493 2.98052 9.08242 3.11667 9.2594L3.96879 10.3665L3.97021 10.3672ZM5.80196 7.99574C5.95822 7.94963 6.09381 7.85107 6.18588 7.71665L7.04792 6.35665L7.98009 7.71665C8.07288 7.85053 8.20746 7.9497 8.364 7.99574L9.92446 8.39595L8.91863 9.70282C8.81946 9.83174 8.76775 9.99111 8.772 10.154L8.874 11.7619L7.32063 11.2094C7.16714 11.1549 6.99953 11.1549 6.84604 11.2094L5.34934 11.803L5.39396 10.154C5.39829 9.99126 5.34652 9.83195 5.24734 9.70282L4.22025 8.46253L5.80196 7.99574ZM13.408 8.42782L13.3606 10.1547C13.3554 10.356 13.3905 10.5563 13.4639 10.7439C13.5373 10.9314 13.6475 11.1023 13.7879 11.2466C13.9284 11.3909 14.0963 11.5056 14.2818 11.584C14.4673 11.6624 14.6666 11.7029 14.8679 11.7032C15.0372 11.7032 15.2079 11.6741 15.373 11.616L17.0007 11.0373L18.6285 11.616C18.8593 11.6977 19.1064 11.7221 19.3487 11.6871C19.591 11.6522 19.8213 11.559 20.0196 11.4156C20.2177 11.2714 20.3778 11.0813 20.486 10.8615C20.5942 10.6417 20.6474 10.3989 20.6408 10.154L20.5934 8.42782L21.6467 7.05861C21.7958 6.86436 21.8955 6.63671 21.937 6.39534C21.9785 6.15396 21.9606 5.90611 21.8848 5.6732C21.8091 5.44028 21.6778 5.22931 21.5023 5.05849C21.3268 4.88768 21.1123 4.76216 20.8774 4.69278L19.2206 4.20403L18.2445 2.77957C18.1059 2.57767 17.9203 2.41254 17.7035 2.29846C17.4868 2.18437 17.2456 2.12476 17.0007 2.12476C16.7558 2.12476 16.5146 2.18437 16.2979 2.29846C16.0812 2.41254 15.8955 2.57767 15.7569 2.77957L14.7808 4.20403L13.1233 4.69278C12.8885 4.76224 12.6741 4.88782 12.4986 5.05867C12.3232 5.22953 12.192 5.44051 12.1163 5.67342C12.0407 5.90632 12.0228 6.15414 12.0644 6.39547C12.1059 6.63681 12.2056 6.86441 12.3548 7.05861L13.408 8.42782ZM13.4633 6.11157C13.4782 6.06553 13.5122 6.05561 13.5235 6.05207L15.4225 5.49249C15.5791 5.44652 15.7149 5.34795 15.8072 5.2134L16.9256 3.5807C16.932 3.57078 16.9525 3.54103 17 3.54103C17.0475 3.54103 17.0687 3.57078 17.0744 3.5807L18.1928 5.2134C18.2849 5.34728 18.4209 5.44645 18.5775 5.49249L20.4758 6.05207C20.4878 6.05561 20.5218 6.06553 20.5367 6.11157C20.5418 6.12557 20.5432 6.14069 20.5406 6.15537C20.538 6.17006 20.5315 6.18378 20.5218 6.19515L19.3148 7.7634C19.2157 7.89232 19.164 8.0524 19.1682 8.21532L19.2228 10.193C19.2228 10.205 19.2242 10.2404 19.1852 10.2688C19.1463 10.2964 19.1123 10.2844 19.1016 10.2808L17.2366 9.61782C17.0831 9.56325 16.9155 9.56325 16.762 9.61782L14.897 10.2808C14.8832 10.2863 14.8682 10.288 14.8536 10.2859C14.8389 10.2838 14.8251 10.2779 14.8134 10.2688C14.801 10.2606 14.791 10.2492 14.7844 10.2359C14.7778 10.2226 14.7749 10.2078 14.7758 10.193L14.8304 8.21461C14.8347 8.05163 14.7829 7.8921 14.6838 7.7627L13.4768 6.19445C13.4672 6.18304 13.4607 6.16931 13.4581 6.15464C13.4555 6.13997 13.4568 6.12488 13.4619 6.11086L13.4633 6.11157Z"
      fill={props.color || "#131313"}
    />
  </svg>
);
export const ScopIcon = (props) => (
  <svg
    width={34}
    height={34}
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.6048 8.58667C26.1424 8.58667 25.6904 8.72378 25.3059 8.98067C24.9214 9.23756 24.6218 9.60269 24.4448 10.0299C24.2679 10.4571 24.2216 10.9271 24.3118 11.3806C24.402 11.8342 24.6247 12.2507 24.9516 12.5777C25.2786 12.9046 25.6952 13.1273 26.1487 13.2175C26.6022 13.3077 27.0722 13.2614 27.4994 13.0845C27.9266 12.9075 28.2917 12.6079 28.5486 12.2234C28.8055 11.8389 28.9426 11.3869 28.9426 10.9246C28.9419 10.3047 28.6953 9.71053 28.2571 9.27225C27.8188 8.83398 27.2246 8.58742 26.6048 8.58667ZM26.6285 11.8363C26.6199 11.8363 26.6119 11.8339 26.6033 11.8339C26.5948 11.8339 26.5881 11.8339 26.5801 11.8363C26.3397 11.83 26.1114 11.7293 25.9447 11.556C25.7779 11.3827 25.6862 11.1506 25.6893 10.9101C25.6925 10.6697 25.7902 10.4401 25.9613 10.2711C26.1325 10.1022 26.3633 10.0075 26.6038 10.0075C26.8443 10.0075 27.0751 10.1022 27.2463 10.2711C27.4174 10.4401 27.5152 10.6697 27.5183 10.9101C27.5214 11.1506 27.4297 11.3827 27.263 11.556C27.0962 11.7293 26.868 11.83 26.6275 11.8363H26.6285Z"
      fill={props.color || "#131313"}
    />
    <path
      d="M26.6047 6.05405C25.3755 6.05381 24.1918 6.51868 23.2912 7.35529C22.3907 8.1919 21.84 9.33828 21.7499 10.5642C21.6597 11.7901 22.0368 13.0047 22.8053 13.964C23.5738 14.9233 24.6768 15.5563 25.8928 15.7359V23.3485C25.8928 25.2398 25.1415 27.0537 23.8041 28.3911C22.4667 29.7285 20.6528 30.4798 18.7615 30.4798C16.8701 30.4798 15.0563 29.7285 13.7189 28.3911C12.3815 27.0537 11.6302 25.2398 11.6302 23.3485V21.938C12.6936 21.7683 13.662 21.2259 14.3623 20.4078C15.0627 19.5898 15.4493 18.5493 15.4531 17.4725C16.6402 16.6737 17.6131 15.5955 18.2861 14.3328C18.9591 13.0701 19.3117 11.6614 19.313 10.2305V5.35117C19.3126 4.72772 19.0648 4.12991 18.6239 3.68906C18.1831 3.24821 17.5853 3.00038 16.9618 3H14.9642C14.7754 3 14.5943 3.075 14.4608 3.20851C14.3273 3.34202 14.2523 3.52309 14.2523 3.7119C14.2523 3.90071 14.3273 4.08178 14.4608 4.21529C14.5943 4.3488 14.7754 4.4238 14.9642 4.4238H16.9618C17.2076 4.42405 17.4431 4.52188 17.6168 4.69578C17.7904 4.86969 17.8879 5.10542 17.8878 5.35117V10.2305C17.8878 13.9168 15.1194 17.0648 11.586 17.3941C10.6178 17.4915 9.63987 17.3829 8.71656 17.0755C7.79325 16.7681 6.94541 16.2689 6.22873 15.6106C5.51129 14.9562 4.938 14.1596 4.54537 13.2715C4.15275 12.3834 3.9494 11.4232 3.94828 10.4522V5.35117C3.94815 5.10542 4.04562 4.86969 4.21925 4.69578C4.39289 4.52188 4.62848 4.42405 4.87422 4.4238H6.87181C7.06062 4.4238 7.24169 4.3488 7.3752 4.21529C7.50871 4.08178 7.58371 3.90071 7.58371 3.7119C7.58371 3.52309 7.50871 3.34202 7.3752 3.20851C7.24169 3.075 7.06062 3 6.87181 3H4.87422C4.25101 3.00075 3.65357 3.24875 3.21303 3.68956C2.77249 4.13037 2.52485 4.72796 2.52448 5.35117V10.4522C2.52575 11.6212 2.77049 12.7772 3.24311 13.8465C3.71573 14.9158 4.40587 15.8749 5.26956 16.6628C5.61925 16.9795 5.99469 17.2665 6.39199 17.5209C6.40602 18.5881 6.79611 19.6161 7.49358 20.424C8.19105 21.2319 9.15118 21.7679 10.2049 21.9375V23.3485C10.2049 25.6174 11.1063 27.7935 12.7107 29.3979C14.3151 31.0023 16.4911 31.9036 18.7601 31.9036C21.029 31.9036 23.2051 31.0023 24.8095 29.3979C26.4139 27.7935 27.3152 25.6174 27.3152 23.3485V15.7368C28.5312 15.5573 29.6343 14.9243 30.4028 13.9649C31.1713 13.0056 31.5483 11.791 31.4582 10.5651C31.368 9.33923 30.8174 8.19285 29.9168 7.35624C29.0163 6.51963 27.8325 6.05476 26.6033 6.055L26.6047 6.05405ZM7.93112 18.3078C8.88027 18.669 9.88751 18.8535 10.9031 18.8521C11.1736 18.8521 11.4454 18.8395 11.7184 18.8142C12.4723 18.7413 13.2118 18.5613 13.9149 18.2798C13.7363 18.9354 13.3481 19.5147 12.8095 19.9291C12.2709 20.3435 11.6116 20.5703 10.932 20.5749H10.8988C10.2253 20.5694 9.57183 20.3454 9.03663 19.9366C8.50144 19.5277 8.11348 18.9561 7.93112 18.3078ZM26.6133 14.3686H26.5948C25.6812 14.3661 24.806 14.0012 24.1614 13.3539C23.5167 12.7067 23.1553 11.83 23.1565 10.9165C23.1578 10.0029 23.5215 9.12724 24.1679 8.48171C24.8143 7.83617 25.6905 7.47359 26.604 7.47359C27.5176 7.47359 28.3937 7.83617 29.0401 8.48171C29.6865 9.12724 30.0503 10.0029 30.0515 10.9165C30.0527 11.83 29.6913 12.7067 29.0467 13.3539C28.402 14.0012 27.5268 14.3661 26.6133 14.3686Z"
      fill={props.color || "#131313"}
    />
  </svg>
);
export const ShakeHand = (props) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_145_319)">
      <path
        d="M49.7945 21.321L41.4286 10.4501C41.1155 10.049 40.5577 9.95111 40.1272 10.2251L34.726 13.6595H27.681C27.593 13.6595 27.4951 13.6791 27.407 13.7085L21.9472 15.2838L16.2818 13.7378L10.7632 10.2251C10.3425 9.9609 9.78474 10.049 9.47163 10.4404L0.215265 21.8983C-0.117416 22.3092 -0.0587071 22.9159 0.342467 23.2584L5.1957 27.4364L9.5499 33.2975C8.27789 34.6576 8.29746 36.7906 9.62818 38.1214C10.2153 38.7085 10.9589 39.0411 11.7319 39.1194C11.7025 39.2955 11.6928 39.4717 11.6928 39.6478C11.6928 40.5773 12.0548 41.4482 12.7104 42.094C13.3659 42.7495 14.2368 43.1116 15.1566 43.1116C15.1663 43.1116 15.1859 43.1116 15.1957 43.1116C15.1957 43.1312 15.1957 43.1605 15.1957 43.1801C15.1957 44.1096 15.5577 44.9805 16.2133 45.6263C16.8689 46.2818 17.7397 46.6439 18.6595 46.6439C18.8454 46.6439 19.0215 46.6243 19.1977 46.6047C19.2759 47.3777 19.6086 48.1214 20.1957 48.7182C20.8708 49.3934 21.7613 49.7358 22.6419 49.7358C23.5225 49.7358 24.4129 49.3934 25.0881 48.7182L25.6164 48.1899L25.8415 48.366C26.5069 49.0118 27.3777 49.3347 28.2485 49.3347C29.1389 49.3347 30.0196 48.9922 30.6947 48.3171C31.3797 47.6321 31.7221 46.7222 31.7123 45.8122C32.6125 45.822 33.5225 45.4893 34.2172 44.8043C34.9022 44.1194 35.2446 43.2094 35.2348 42.2994C36.1742 42.319 37.0744 41.957 37.7397 41.2818C38.4247 40.5969 38.7671 39.6869 38.7573 38.7769C39.6673 38.7867 40.5675 38.454 41.2622 37.7593C42.4364 36.5852 42.593 34.7652 41.7221 33.4247L44.9022 26.7711L49.6771 22.6615C50.0489 22.3288 50.1174 21.7319 49.7945 21.321ZM10.4501 12.3484L14.4129 14.8631L5.79256 25.3621L2.33855 22.3875L10.4501 12.3484ZM11.0078 34.6087L12.2016 33.4149C12.2407 33.3758 12.2798 33.3464 12.319 33.3171C12.5538 33.1312 12.8376 33.0137 13.1311 32.9844C13.1409 32.9844 13.1507 32.9844 13.1605 32.9844C13.1996 32.9844 13.2485 32.9746 13.2877 32.9746C13.6986 32.9844 14.0802 33.1507 14.364 33.4443C14.9217 34.0313 14.8924 34.9903 14.2955 35.5773L13.1409 36.7319C12.5538 37.319 11.6047 37.319 11.0176 36.7319C10.4207 36.1449 10.4207 35.1957 11.0078 34.6087ZM14.0802 40.7045C13.7965 40.4208 13.6399 40.0392 13.6399 39.638C13.6399 39.2368 13.7965 38.8552 14.0802 38.5715L16.3992 36.2525C16.8395 35.8122 17.544 35.685 18.1115 35.9589C18.6986 36.2329 19.0215 36.8689 18.9432 37.5147C18.8943 37.8572 18.7378 38.1801 18.4932 38.4247L16.2133 40.7045C15.9296 40.9883 15.5479 41.1449 15.1468 41.1449C14.7456 41.1449 14.364 40.9883 14.0802 40.7045ZM17.5832 44.2466C17.2994 43.9629 17.1429 43.5812 17.1429 43.1801C17.1429 42.7789 17.2994 42.3973 17.5832 42.1135L19.9022 39.7946C20.3816 39.3249 21.135 39.2173 21.7221 39.5597C22.2505 39.8728 22.5342 40.4795 22.4364 41.0764C22.3875 41.409 22.2309 41.7222 21.9863 41.957L19.7065 44.2368C19.4227 44.5206 19.0411 44.6771 18.6399 44.6771C18.2485 44.6869 17.8669 44.5304 17.5832 44.2466ZM21.5753 47.3288C20.9883 46.7417 20.9883 45.7926 21.5753 45.2055L22.7691 44.0118C22.8082 43.9726 22.8474 43.9433 22.8865 43.9139C23.0822 43.7574 23.3072 43.6497 23.5519 43.6008C23.5616 43.6008 23.5616 43.6008 23.5714 43.6008C23.6106 43.591 23.6595 43.591 23.6986 43.5812C23.7182 43.5812 23.7378 43.5812 23.7476 43.5812C23.7867 43.5812 23.816 43.5812 23.8552 43.5812C24.2661 43.591 24.6478 43.7574 24.9315 44.0509C24.9706 44.0901 25 44.1292 25.0294 44.1683C25.4795 44.7554 25.4207 45.636 24.863 46.1938L23.7084 47.3484C23.1115 47.9159 22.1624 47.9159 21.5753 47.3288ZM39.863 36.3797C39.2759 36.9668 38.3268 36.9668 37.7397 36.3797C37.7202 36.3601 37.7006 36.3405 37.6712 36.321L31.3699 29.9511C30.9883 29.5695 30.3718 29.5597 29.9804 29.9413C29.5988 30.3229 29.589 30.9394 29.9706 31.3308L36.3405 37.7691C36.9276 38.3562 36.9276 39.3053 36.3405 39.8924C36.0568 40.1762 35.6751 40.3327 35.274 40.3327C34.8728 40.3327 34.4912 40.1762 34.2074 39.8924L29.9413 35.5871C29.5597 35.2055 28.9432 35.1957 28.5519 35.5773C28.1703 35.9589 28.1605 36.5754 28.5421 36.9668L32.7397 41.2036C32.7593 41.2329 32.7887 41.2525 32.8082 41.2818C33.3953 41.8689 33.3953 42.818 32.8082 43.4051C32.2211 43.9922 31.2622 43.9922 30.6849 43.4051L28.3562 41.0568C27.9746 40.6752 27.3581 40.6654 26.9667 41.047C26.5851 41.4286 26.5753 42.045 26.9569 42.4364L29.2172 44.7261C29.2368 44.7554 29.2661 44.775 29.2857 44.8043C29.8728 45.3914 29.8728 46.3405 29.2857 46.9276C28.6986 47.5147 27.7495 47.5147 27.1624 46.9276C27.0939 46.8591 27.0157 46.8102 26.9374 46.7515C26.8689 46.7026 26.8591 46.6732 26.8885 46.595C26.9178 46.5167 26.9667 46.4482 27.0059 46.3699C27.045 46.2818 27.0744 46.1938 27.1037 46.0959C27.2505 45.6067 27.2994 45.0881 27.2309 44.5891C27.1037 43.6204 26.5753 42.7495 25.7632 42.2016C25.3327 41.9081 24.8239 41.7124 24.3053 41.6341C24.5597 40.5186 24.2564 39.3151 23.4638 38.4834C22.818 37.7985 21.9374 37.4169 20.998 37.3973C20.9589 37.3973 20.9296 37.3973 20.8904 37.3973C20.91 36.4971 20.5871 35.6067 19.9609 34.9511C19.3151 34.2662 18.4344 33.8846 17.4951 33.865C17.2114 33.865 16.9276 33.8944 16.6634 33.9531C16.546 33.1409 16.135 32.3875 15.5186 31.8494C14.9022 31.3112 14.1292 31.0177 13.3072 31.0079C12.4364 30.9981 11.5851 31.3112 10.9393 31.8983L7.15264 26.7906L16.2231 15.7437L19.1096 16.5362L15.3327 23.1996C14.8728 24.002 14.7652 24.9413 15.0098 25.8317C15.2544 26.7222 15.8317 27.4658 16.6438 27.9257C16.6928 27.955 16.7417 27.9844 16.8004 28.004C16.8004 28.004 16.8102 28.004 16.8102 28.0137C16.9472 28.0822 17.0841 28.1409 17.2211 28.1899C17.8767 28.4149 18.591 28.4443 19.2759 28.2486C20.1663 28.004 20.91 27.4267 21.3699 26.6145L23.8258 22.2897L28.2094 22.6028L39.8728 34.2662C40.4501 34.8435 40.4501 35.7926 39.863 36.3797ZM40.2642 31.8885L29.3249 20.9492C29.3053 20.9296 29.2857 20.91 29.2564 20.8904C29.0998 20.7632 28.9041 20.6752 28.6986 20.6654L23.3366 20.2838C22.9648 20.2544 22.593 20.4599 22.4168 20.7828L19.6673 25.6458C19.4716 25.9981 19.1487 26.2427 18.7573 26.3503C18.3659 26.458 17.9648 26.409 17.6125 26.2133C17.2603 26.0176 17.0157 25.6948 16.908 25.3034C16.8004 24.912 16.8493 24.5108 17.045 24.1586L20.7241 17.6615L22.2114 17.231C22.2211 17.231 22.2309 17.2212 22.2407 17.2212L27.8082 15.6165H34.5401L42.9354 26.2916L40.2642 31.8885ZM44.227 24.7554L36.4579 14.8826L40.4207 12.3582L47.681 21.7809L44.227 24.7554Z"
        fill={props?.color || "#BED643"}
      />
    </g>
    <defs>
      <clipPath id="clip0_145_319">
        <rect width={50} height={50} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TestimonialQuote = (props) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_14_724)">
      <g clipPath="url(#clip1_14_724)">
        <mask
          id="mask0_14_724"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={50}
          height={50}
        >
          <path d="M50 0H0V50H50V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_14_724)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.42376 4.01424C5.99606 4.50814 2.73776 6.85594 1.17126 9.96064C-1.56124 15.3763 0.712563 21.9543 6.26116 24.6855C8.60236 25.8378 11.0616 26.0623 13.7967 25.373L14.6538 25.157L14.8616 25.3647C15.0624 25.5656 15.0657 25.6079 14.9611 26.6351C14.7393 28.8138 14.2671 30.4665 13.3219 32.3727C12.4819 34.0664 11.6265 35.2443 10.1562 36.731C8.27766 38.6307 6.12956 40.1096 3.70726 41.1707C2.06036 41.8921 1.93766 42.1016 2.13986 43.845C2.29796 45.2083 2.48026 45.6097 3.07056 45.8954C3.64206 46.1722 3.89136 46.1371 5.14836 45.6038C13.7395 41.9587 19.8215 36.3938 22.4904 29.736C23.6741 26.7833 24.1651 24.1782 24.1652 20.8493C24.1653 18.6497 24.0682 17.591 23.7136 15.9266C22.9168 12.187 20.6016 8.48884 17.6781 6.28604C15.2692 4.47084 12.1714 3.61824 9.42376 4.01424ZM9.61906 5.56024C6.97976 5.99684 4.61406 7.50444 3.13666 9.69124C2.65686 10.4012 2.07586 11.6822 1.84046 12.5485C1.52866 13.6965 1.52776 15.9198 1.83866 17.0895C2.33626 18.9617 3.58076 20.8971 5.01076 22.0228C6.35116 23.0778 7.20556 23.5136 8.78906 23.95C9.94056 24.2674 12.0323 24.241 13.3069 23.8928C13.8312 23.7497 14.4216 23.6325 14.6188 23.6325C15.1014 23.6325 15.7582 23.9649 16.1036 24.384C16.5714 24.9516 16.6556 25.4395 16.5198 26.7972C15.9455 32.5416 12.9578 37.2845 7.74356 40.7294C6.62866 41.4661 5.26756 42.212 4.26306 42.6368L3.59436 42.9196L3.65266 43.3483C3.68476 43.5841 3.71156 43.8697 3.71236 43.9831C3.71596 44.4754 3.82796 44.4765 4.94356 43.995C9.23096 42.1448 13.516 39.287 16.1447 36.5247C19.7711 32.714 21.7478 28.6757 22.4795 23.5836C22.6711 22.2504 22.6391 18.9576 22.4206 17.529C21.9091 14.1834 20.5652 11.332 18.3937 8.98494C17.0602 7.54354 14.8532 6.20134 13.0859 5.75724C12.1698 5.52694 10.4211 5.42754 9.61906 5.56024Z"
            fill={colors["--icon"] || "#363435"}
          />
          <path
            d="M8.00571 8.86218C8.18331 8.63658 8.46561 8.53098 9.61891 8.25878C10.1012 8.14498 11.8802 8.28938 12.443 8.48808C13.6151 8.90178 14.8435 9.95538 14.8435 10.547C14.8435 10.8999 14.4687 11.3279 14.1595 11.3279C13.913 11.3279 13.3787 11.0646 13.3787 10.9431C13.3787 10.8953 13.1569 10.6935 12.8858 10.4945C11.9632 9.81728 10.6946 9.60298 9.42361 9.90998C8.53771 10.1238 8.25111 10.1018 8.01471 9.80108C7.76041 9.47778 7.75761 9.17768 8.00571 8.86218Z"
            fill={props?.color || "#BED643"}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.4091 4.01424C31.9813 4.50814 28.723 6.85594 27.1565 9.96064C24.424 15.3763 26.6978 21.9543 32.2465 24.6855C34.5877 25.8378 37.0469 26.0623 39.7819 25.373L40.6391 25.157L40.8469 25.3647C41.0477 25.5656 41.051 25.6079 40.9464 26.6351C40.7246 28.8138 40.2524 30.4665 39.3071 32.3727C38.4672 34.0664 37.6117 35.2443 36.1415 36.731C34.263 38.6307 32.1148 40.1096 29.6926 41.1707C28.0457 41.8921 27.9229 42.1016 28.1252 43.845C28.2833 45.2083 28.4655 45.6097 29.0558 45.8954C29.6273 46.1722 29.8766 46.1371 31.1337 45.6038C39.7248 41.9587 45.8068 36.3938 48.4757 29.736C49.6594 26.7833 50.1504 24.1782 50.1505 20.8493C50.1506 18.6497 50.0534 17.591 49.6989 15.9266C48.9021 12.187 46.5869 8.48884 43.6634 6.28604C41.2545 4.47084 38.1566 3.61824 35.4091 4.01424ZM35.6044 5.56024C32.965 5.99684 30.5993 7.50444 29.122 9.69124C28.6422 10.4012 28.0611 11.6822 27.8258 12.5485C27.514 13.6965 27.5131 15.9198 27.8239 17.0895C28.3216 18.9617 29.5661 20.8971 30.9961 22.0228C32.3364 23.0778 33.1908 23.5136 34.7743 23.95C35.9259 24.2674 38.0176 24.241 39.2922 23.8928C39.8165 23.7497 40.4069 23.6325 40.6041 23.6325C41.0866 23.6325 41.7435 23.9649 42.0889 24.384C42.5567 24.9516 42.6408 25.4395 42.5051 26.7972C41.9308 32.5416 38.9431 37.2845 33.7289 40.7294C32.614 41.4661 31.2528 42.212 30.2483 42.6368L29.5797 42.9196L29.638 43.3483C29.67 43.5841 29.6969 43.8697 29.6976 43.9831C29.7013 44.4754 29.8133 44.4765 30.9289 43.995C35.2163 42.1448 39.5013 39.287 42.13 36.5247C45.7564 32.714 47.7331 28.6757 48.4648 23.5836C48.6564 22.2504 48.6243 18.9576 48.4059 17.529C47.8944 14.1834 46.5505 11.332 44.379 8.98494C43.0455 7.54354 40.8385 6.20134 39.0712 5.75724C38.1551 5.52694 36.4063 5.42754 35.6044 5.56024Z"
            fill={colors["--icon"] || "#363435"}
          />
          <path
            d="M33.9911 8.86218C34.1686 8.63658 34.4509 8.53098 35.6043 8.25878C36.0866 8.14498 37.8656 8.28938 38.4284 8.48808C39.6005 8.90178 40.8289 9.95538 40.8289 10.547C40.8289 10.8999 40.4541 11.3279 40.1449 11.3279C39.8983 11.3279 39.364 11.0646 39.364 10.9431C39.364 10.8953 39.1423 10.6935 38.8712 10.4945C37.9486 9.81728 36.6799 9.60298 35.4089 9.90998C34.523 10.1238 34.2365 10.1018 34.0001 9.80108C33.7458 9.47778 33.7429 9.17768 33.9911 8.86218Z"
            fill={props?.color || "#BED643"}
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_14_724">
        <rect
          width={50}
          height={50}
          fill="white"
          transform="matrix(-1 0 0 -1 50 50)"
        />
      </clipPath>
      <clipPath id="clip1_14_724">
        <rect
          width={50}
          height={50}
          fill="white"
          transform="matrix(-1 0 0 -1 50 50)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const FullStar = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_123_627)">
      <path
        d="M7.9974 0.833252C8.69693 0.833252 9.24793 1.36161 9.59966 2.07453L10.7744 4.44336C10.81 4.51667 10.8945 4.61991 11.0214 4.71435C11.1482 4.80869 11.2724 4.86073 11.3541 4.87445L13.4805 5.23067C14.2486 5.35974 14.8924 5.73625 15.1014 6.39185C15.3102 7.04692 15.0043 7.72765 14.4519 8.28099L14.4513 8.28159L12.7994 9.94719C12.7339 10.0132 12.6606 10.1375 12.6146 10.2995C12.5689 10.4605 12.5649 10.6071 12.5856 10.7017L12.5859 10.7031L13.0585 12.7635C13.2545 13.6211 13.1895 14.4715 12.5847 14.9161C11.9778 15.3621 11.1485 15.1644 10.395 14.7157L8.40173 13.5259C8.318 13.4759 8.17426 13.4354 8.00073 13.4354C7.82846 13.4354 7.68173 13.4754 7.59253 13.5273L7.59126 13.528L5.60192 14.7154C4.84936 15.1657 4.02102 15.3599 3.41407 14.9134C2.80966 14.4687 2.74142 13.6199 2.93807 12.7631L3.4106 10.7031L3.41088 10.7017C3.4316 10.6071 3.42755 10.4605 3.38186 10.2995C3.33586 10.1375 3.26252 10.0132 3.19705 9.94719L1.5439 8.28032C0.995098 7.72699 0.690138 7.04685 0.897298 6.39275C1.10506 5.73675 1.74762 5.35979 2.51622 5.23063L4.64088 4.87471L4.64155 4.8746C4.71944 4.86109 4.8418 4.80963 4.96832 4.71504C5.09507 4.62028 5.17972 4.51682 5.21541 4.44336L5.21721 4.4397L6.39041 2.0739L6.39088 2.07297C6.746 1.36064 7.29866 0.833252 7.9974 0.833252Z"
        fill={props?.color || "#E6A733"}
      />
    </g>
    <defs>
      <clipPath id="clip0_123_627">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HalfStar = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M7.83205 0.666748C8.53159 0.666748 9.08259 1.1951 9.43432 1.90802L10.6091 4.27685C10.6447 4.35017 10.7291 4.4534 10.8561 4.54784C10.9829 4.64218 11.1071 4.69422 11.1887 4.70795L13.3151 5.06417C14.0833 5.19323 14.7271 5.56974 14.9361 6.22535C15.1449 6.88041 14.8389 7.56115 14.2865 8.11448L14.286 8.11508L12.6341 9.78068C12.5686 9.84668 12.4953 9.97101 12.4493 10.133C12.4036 10.2939 12.3995 10.4405 12.4203 10.5352L12.4205 10.5365L12.8931 12.597C13.0892 13.4545 13.0242 14.3049 12.4194 14.7495C11.8125 15.1956 10.9831 14.9979 10.2297 14.5491L8.23639 13.3594C8.15265 13.3094 8.00892 13.2689 7.83539 13.2689C7.66312 13.2689 7.51639 13.3089 7.42719 13.3607L7.42592 13.3615L5.43657 14.5489C4.68402 14.9992 3.85568 15.1934 3.24873 14.7469C2.64431 14.3022 2.57608 13.4534 2.77273 12.5965L3.24525 10.5365L3.24554 10.5352C3.26626 10.4405 3.26221 10.2939 3.21652 10.133C3.17052 9.97101 3.09718 9.84668 3.03171 9.78068L1.37855 8.11381C0.829754 7.56048 0.524794 6.88035 0.731954 6.22625C0.939714 5.57025 1.58227 5.19328 2.35087 5.06412L4.47553 4.70821L4.47621 4.70809C4.5541 4.69458 4.67645 4.64312 4.80297 4.54853C4.92973 4.45377 5.01438 4.35031 5.05007 4.27685L5.05187 4.27319L6.22507 1.90739L6.22553 1.90646C6.58065 1.19413 7.13332 0.666748 7.83205 0.666748Z"
      fill={props?.color || "#E6A733"}
    />
    <path
      d="M6.22553 1.90646C6.58065 1.19413 7.13332 0.666748 7.83205 0.666748V13.2689C7.66125 13.2694 7.51579 13.3092 7.42719 13.3607L7.42592 13.3615L5.43657 14.5489C4.68402 14.9992 3.85568 15.1934 3.24873 14.7469C2.64431 14.3022 2.57608 13.4534 2.77273 12.5965L3.24525 10.5365L3.24554 10.5352C3.26626 10.4405 3.26221 10.2939 3.21652 10.133C3.17052 9.97101 3.09718 9.84668 3.03171 9.78068L1.37855 8.11381C0.829754 7.56048 0.524794 6.88035 0.731954 6.22625C0.939714 5.57025 1.58227 5.19328 2.35087 5.06412L4.47553 4.70821L4.47621 4.70809C4.5541 4.69458 4.67645 4.64312 4.80297 4.54853C4.92973 4.45377 5.01438 4.35031 5.05007 4.27685L5.05187 4.27319L6.22507 1.90739L6.22553 1.90646Z"
      fill={props?.color || "#E6A733"}
    />
  </svg>
);

export const PreviousAero = ({ size = 16, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14.1585 8.98234C14.1012 8.99163 14.0433 8.99593 13.9853 8.99517H4.10854L4.3239 9.09534C4.53441 9.19499 4.72593 9.33058 4.88986 9.49602L7.65954 12.2657C8.02431 12.6139 8.0856 13.1741 7.80479 13.5929C7.47795 14.0393 6.85118 14.1362 6.4048 13.8094C6.36873 13.783 6.33447 13.7542 6.30225 13.7232L1.29379 8.7147C0.902374 8.32373 0.90203 7.6895 1.293 7.29809L1.29379 7.29731L6.30225 2.28884C6.69397 1.89822 7.3282 1.89909 7.71886 2.29082C7.7496 2.32165 7.7783 2.35445 7.80479 2.38901C8.0856 2.80788 8.02431 3.36804 7.65954 3.71626L4.89487 6.49094C4.74791 6.63807 4.57894 6.76142 4.39402 6.85656L4.09352 6.99179L13.9301 6.99179C14.4418 6.97279 14.8908 7.33024 14.9869 7.83321C15.0755 8.37929 14.7046 8.89375 14.1585 8.98234Z"
      fill={color}
    />
  </svg>
);
export const NextAero = ({ size = 16, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.84148 8.98234C1.89875 8.99163 1.95672 8.99593 2.01474 8.99517H11.8915L11.6761 9.09534C11.4656 9.19499 11.2741 9.33058 11.1101 9.49602L8.34046 12.2657C7.97569 12.6139 7.9144 13.1741 8.19521 13.5929C8.52205 14.0393 9.14882 14.1362 9.5952 13.8094C9.63127 13.783 9.66553 13.7542 9.69775 13.7232L14.7062 8.7147C15.0976 8.32373 15.098 7.6895 14.707 7.29809L14.7062 7.29731L9.69775 2.28884C9.30603 1.89822 8.6718 1.89909 8.28114 2.29082C8.2504 2.32165 8.2217 2.35445 8.19521 2.38901C7.9144 2.80788 7.97569 3.36804 8.34046 3.71626L11.1051 6.49094C11.2521 6.63807 11.4211 6.76142 11.606 6.85656L11.9065 6.99179L2.06987 6.99179C1.55816 6.97279 1.10921 7.33024 1.01308 7.83321C0.924523 8.37929 1.2954 8.89375 1.84148 8.98234Z"
      fill={color}
    />
  </svg>
);
export const InstagramImage = () => (
  <svg
    width={42}
    height={43}
    viewBox="0 0 42 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.62501 3.05772C-0.675487 6.48597 1.30162e-05 10.1277 1.30162e-05 21.1912C1.30162e-05 30.3787 -1.60299 39.589 6.78651 41.7572C9.40626 42.431 32.6183 42.431 35.2345 41.7537C38.7275 40.8525 41.5695 38.0192 41.958 33.079C42.0123 32.3895 42.0123 10.0052 41.9563 9.30172C41.5433 4.03947 38.304 1.00672 34.0358 0.392471C33.0575 0.250721 32.8615 0.208721 27.8425 0.199971C10.0398 0.208721 6.13726 -0.584029 2.62501 3.05772Z"
      fill="url(#paint0_linear_279_48)"
    />
    <path
      d="M20.9965 5.69319C14.6423 5.69319 8.60826 5.12794 6.30351 11.0429C5.35151 13.4859 5.48976 16.6587 5.48976 21.2017C5.48976 25.1882 5.36201 28.9349 6.30351 31.3587C8.60301 37.2772 14.686 36.7102 20.993 36.7102C27.0778 36.7102 33.3515 37.3437 35.6843 31.3587C36.638 28.8912 36.498 25.7657 36.498 21.2017C36.498 15.1432 36.8323 11.2319 33.894 8.29544C30.919 5.32044 26.8958 5.69319 20.9895 5.69319H20.9965ZM19.607 8.48794C32.8615 8.46694 34.5485 6.99344 33.6175 27.4632C33.2868 34.7029 27.7743 33.9084 20.9983 33.9084C8.64326 33.9084 8.28801 33.5549 8.28801 21.1947C8.28801 8.69094 9.26801 8.49494 19.607 8.48444V8.48794ZM29.274 11.0622C28.7806 11.0622 28.3075 11.2582 27.9586 11.607C27.6097 11.9559 27.4138 12.4291 27.4138 12.9224C27.4138 13.4158 27.6097 13.889 27.9586 14.2378C28.3075 14.5867 28.7806 14.7827 29.274 14.7827C29.7674 14.7827 30.2405 14.5867 30.5894 14.2378C30.9383 13.889 31.1343 13.4158 31.1343 12.9224C31.1343 12.4291 30.9383 11.9559 30.5894 11.607C30.2405 11.2582 29.7674 11.0622 29.274 11.0622ZM20.9965 13.2374C19.9507 13.2376 18.9152 13.4436 17.9491 13.8439C16.983 14.2443 16.1052 14.8309 15.3658 15.5705C13.8726 17.0641 13.0338 19.0897 13.034 21.2017C13.0342 23.3137 13.8735 25.3391 15.367 26.8324C16.8606 28.3256 18.8862 29.1644 20.9983 29.1642C23.1103 29.164 25.1357 28.3247 26.629 26.8312C28.1222 25.3376 28.961 23.312 28.9608 21.1999C28.9605 19.0879 28.1213 17.0625 26.6277 15.5692C25.1341 14.076 23.1085 13.2372 20.9965 13.2374ZM20.9965 16.0322C27.8303 16.0322 27.839 26.3712 20.9965 26.3712C14.1645 26.3712 14.154 16.0322 20.9965 16.0322Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_279_48"
        x1="2.70555"
        y1="39.5174"
        x2="41.7401"
        y2="5.73342"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDD55" />
        <stop offset="0.5" stopColor="#FF543E" />
        <stop offset={1} stopColor="#C837AB" />
      </linearGradient>
    </defs>
  </svg>
);
export const FaceBookIcon = ({ size = 18, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.38722 9.82143H5.72402C5.45522 9.82143 5.37122 9.72063 5.37122 9.46863V7.43583C5.37122 7.16703 5.47202 7.08303 5.72402 7.08303H7.38722V5.60463C7.38722 4.93263 7.50482 4.29423 7.84082 3.70623C8.19362 3.10143 8.69762 2.69823 9.33602 2.46303C9.75602 2.31183 10.176 2.24463 10.6296 2.24463H12.276C12.5112 2.24463 12.612 2.34543 12.612 2.58063V4.49583C12.612 4.73103 12.5112 4.83183 12.276 4.83183C11.8224 4.83183 11.3688 4.83183 10.9152 4.84863C10.4616 4.84863 10.2264 5.06703 10.2264 5.53743C10.2096 6.04143 10.2264 6.52863 10.2264 7.04943H12.1752C12.444 7.04943 12.5448 7.15023 12.5448 7.41903V9.45183C12.5448 9.72063 12.4608 9.80463 12.1752 9.80463H10.2264V15.2814C10.2264 15.567 10.1424 15.6678 9.84002 15.6678H7.74002C7.48802 15.6678 7.38722 15.567 7.38722 15.315V9.82143Z"
      fill={color}
    />
  </svg>
);
export const InstagramIcon = ({ size = 18, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.5 1.94775H5.5C3.568 1.94775 2 3.51575 2 5.44775V12.4478C2 14.3798 3.568 15.9478 5.5 15.9478H12.5C14.432 15.9478 16 14.3798 16 12.4478V5.44775C16 3.51575 14.432 1.94775 12.5 1.94775ZM9 12.4478C7.068 12.4478 5.5 10.8798 5.5 8.94775C5.5 7.01575 7.068 5.44775 9 5.44775C10.932 5.44775 12.5 7.01575 12.5 8.94775C12.5 10.8798 10.932 12.4478 9 12.4478ZM12.745 5.88175C12.36 5.88175 12.045 5.56675 12.045 5.18175C12.045 4.79675 12.36 4.48175 12.745 4.48175C13.13 4.48175 13.445 4.79675 13.445 5.18175C13.445 5.56675 13.13 5.88175 12.745 5.88175Z"
      fill={color}
    />
    <path
      d="M8.99999 11.0477C10.1598 11.0477 11.1 10.1075 11.1 8.94766C11.1 7.78786 10.1598 6.84766 8.99999 6.84766C7.8402 6.84766 6.89999 7.78786 6.89999 8.94766C6.89999 10.1075 7.8402 11.0477 8.99999 11.0477Z"
      fill={color}
    />
  </svg>
);
export const LinkedinIcon = ({ size = 18, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.72 15.7203V10.7979C15.72 8.37867 15.1992 6.53067 12.3768 6.53067C11.016 6.53067 10.1088 7.26987 9.7392 7.97547H9.7056V6.74907H7.0344V15.7203H9.8232V11.2683C9.8232 10.0923 10.0416 8.96667 11.4864 8.96667C12.9144 8.96667 12.9312 10.2939 12.9312 11.3355V15.7035H15.72V15.7203ZM2.4984 6.74907H5.2872V15.7203H2.4984V6.74907ZM3.8928 2.28027C3.0024 2.28027 2.28 3.00267 2.28 3.89307C2.28 4.78347 3.0024 5.52267 3.8928 5.52267C4.7832 5.52267 5.5056 4.78347 5.5056 3.89307C5.5056 3.00267 4.7832 2.28027 3.8928 2.28027Z"
      fill={color}
    />
  </svg>
);
export const YoutubeFill = ({ size = 18, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M16.9101 4.87771C16.7199 4.14346 16.1626 3.56467 15.4558 3.36696C14.1646 3 8.99981 3 8.99981 3C8.99981 3 3.8352 3 2.54402 3.35306C1.85084 3.55056 1.27993 4.1436 1.0898 4.87771C0.75 6.21878 0.75 9.00003 0.75 9.00003C0.75 9.00003 0.75 11.7953 1.0898 13.1223C1.28012 13.8564 1.83725 14.4352 2.54412 14.6329C3.84878 15 9.00002 15 9.00002 15C9.00002 15 14.1646 15 15.4558 14.6469C16.1627 14.4493 16.7199 13.8705 16.9102 13.1364C17.2499 11.7952 17.2499 9.01411 17.2499 9.01411C17.2499 9.01411 17.2635 6.21875 16.9101 4.87771ZM7.35543 11.5694V6.43058L11.6502 8.99997L7.35543 11.5694Z"
      fill={color}
    />
  </svg>
);
export const TwitterIcon = ({ size = 18, color = "currentColor", ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15.7032 4.78139C15.1992 4.99979 14.6784 5.15099 14.124 5.21819C14.6952 4.88219 15.132 4.34459 15.3336 3.68939C14.796 4.00859 14.208 4.22699 13.5864 4.36139C13.0824 3.82379 12.36 3.48779 11.5704 3.48779C10.0416 3.48779 8.81521 4.73099 8.81521 6.24299C8.81521 6.46139 8.83201 6.66299 8.88241 6.86459C6.59761 6.76379 4.58161 5.65499 3.22081 3.99179C2.24641 5.73899 3.33841 7.18379 4.06081 7.67099C3.62401 7.67099 3.18721 7.53659 2.81761 7.33499C2.81761 8.69579 3.77521 9.82139 5.01841 10.0734C4.74961 10.1574 4.14481 10.2078 3.77521 10.1238C4.12801 11.2158 5.15281 12.0222 6.34561 12.039C5.40481 12.7782 4.02721 13.3662 2.26321 13.1814C3.48961 13.971 4.93441 14.4246 6.49681 14.4246C11.5704 14.4246 14.3256 10.2246 14.3256 6.59579C14.3256 6.47819 14.3256 6.36059 14.3088 6.24299C14.88 5.82299 15.3504 5.33579 15.7032 4.78139Z"
      fill={color}
    />
  </svg>
);
export const PhoneRing = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.1052 1.68437C11.1799 1.80377 12.1471 2.32372 12.9122 3.08788C13.6773 3.85204 14.1949 4.82029 14.3157 5.89489M9.7543 4.14051C10.2716 4.24144 10.7851 4.46958 11.1578 4.84226C11.5305 5.21495 11.7586 5.72847 11.8596 6.24577M5.33359 10.6661C0.492901 5.82487 1.18124 3.60798 1.69153 2.89361C1.75708 2.77814 3.37288 0.359377 5.10489 1.77846C9.40398 5.31907 4.14027 5.19314 7.57142 8.42914C11.0026 11.6651 10.6816 6.59661 14.2216 10.8948C15.6407 12.6275 13.2219 14.2432 13.1071 14.3081C12.3928 14.8191 10.175 15.5074 5.33359 10.6661Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>


);
export const Mail = ({ color }) => (
  <svg
    width={16}
    height={17}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.59027 3.99156C2.13696 4.41248 1.83337 5.09546 1.83337 6.16683V10.8335C1.83337 11.9048 2.13696 12.5878 2.59027 13.0088C3.05027 13.4359 3.74335 13.6668 4.66671 13.6668H11.3334C12.2567 13.6668 12.9498 13.4359 13.4098 13.0088C13.8631 12.5878 14.1667 11.9048 14.1667 10.8335V6.16683C14.1667 5.09546 13.8631 4.41248 13.4098 3.99156C12.9498 3.56441 12.2567 3.3335 11.3334 3.3335H4.66671C3.74335 3.3335 3.05027 3.56441 2.59027 3.99156ZM1.90981 3.25876C2.61647 2.60258 3.59006 2.3335 4.66671 2.3335H11.3334C12.41 2.3335 13.3836 2.60258 14.0902 3.25876C14.8036 3.92118 15.1667 4.90486 15.1667 6.16683V10.8335C15.1667 12.0955 14.8036 13.0792 14.0902 13.7416C13.3836 14.3978 12.41 14.6668 11.3334 14.6668H4.66671C3.59006 14.6668 2.61647 14.3978 1.90981 13.7416C1.19645 13.0792 0.833374 12.0955 0.833374 10.8335V6.16683C0.833374 4.90486 1.19645 3.92118 1.90981 3.25876Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9089 5.37351C13.0778 5.59201 13.0375 5.90603 12.819 6.07487L9.12098 8.9324C8.46071 9.44253 7.53931 9.44253 6.87904 8.9324L3.181 6.07487C2.96249 5.90603 2.92223 5.59201 3.09107 5.37351C3.25992 5.15499 3.57393 5.11473 3.79244 5.28358L7.49044 8.14107C7.79058 8.373 8.20944 8.373 8.50951 8.14107L12.2076 5.28358C12.4261 5.11473 12.7401 5.15499 12.9089 5.37351Z"
      fill={color}
    />
  </svg>
);
export const LocationIcon = ({ color }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.14307 14.6668C8.14307 14.6668 3.33337 9.53611 3.33337 6.19188C3.33337 2.24581 5.99203 1.3335 8.14307 1.3335C10.123 1.3335 12.6667 2.36563 12.6667 6.19188C12.6667 9.64504 8.14307 14.6668 8.14307 14.6668Z"
      stroke={color}
    />
    <path
      d="M8.00003 7.22129C9.0734 7.22129 9.94354 6.37633 9.94354 5.33403C9.94354 4.29173 9.0734 3.44678 8.00003 3.44678C6.92666 3.44678 6.05652 4.29173 6.05652 5.33403C6.05652 6.37633 6.92666 7.22129 8.00003 7.22129Z"
      stroke={color}
    />
  </svg>
);

export const FilledLocationIcon = ({ color }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C7.58933 1 4 4.72717 4 9.30958C4 15.8207 11.248 22.5435 11.5564 22.8258C11.6784 22.9384 11.8362 23.0007 11.9998 23.0009C12.1635 23.001 12.3214 22.939 12.4436 22.8268C12.752 22.5435 20 15.8207 20 9.30958C20 4.72717 16.4107 1 12 1ZM12 13.8333C9.54933 13.8333 7.55556 11.7773 7.55556 9.25C7.55556 6.72275 9.54933 4.66667 12 4.66667C14.4507 4.66667 16.4444 6.72275 16.4444 9.25C16.4444 11.7773 14.4507 13.8333 12 13.8333Z"
      fill={color}
    />
  </svg>
);

export const BgStar = (props) => (
  <svg
    width={props?.size || 42}
    height={props?.size || 42}
    viewBox="0 0 42 42"
    fill="none"
    className={props?.className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.5327 19.6557C35.8044 20.2502 38.5258 20.7009 41.798 21.1227C38.5252 21.5476 35.8033 22.0051 33.5309 22.6086C30.3559 23.4504 28.0139 24.5859 26.2563 26.3477C24.499 28.1096 23.3723 30.4501 22.5367 33.6125C21.9387 35.8766 21.4842 38.5844 21.0594 41.8361C20.6316 38.5834 20.1703 35.8756 19.5632 33.6115C18.7151 30.4471 17.5715 28.1066 15.7978 26.3458C14.0241 24.5849 11.6666 23.4504 8.47977 22.6076C6.19891 22.0051 3.47049 21.5476 0.194695 21.1227C3.46989 20.7009 6.19781 20.2502 8.47797 19.6557C11.6639 18.8269 14.0218 17.7082 15.7961 15.9632C17.5708 14.2183 18.7148 11.8936 19.5632 8.74173C20.1703 6.48586 20.6316 3.78372 21.0594 0.534668C21.4842 3.78313 21.9387 6.48477 22.5368 8.73994C23.3726 11.8916 24.4997 14.2163 26.258 15.9622C28.0163 17.7072 30.3586 18.8269 33.5327 19.6557Z"
      stroke={props?.color || "#363435"}
      strokeOpacity="0.2"
    />
  </svg>
);
export const Cross = (props) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M30.0943 59.5556C25.905 59.5556 22.5055 56.1717 22.5055 52.0144V7.54117C22.5055 3.38389 25.905 0 30.0943 0C34.1838 0 37.5933 3.38389 37.5933 7.54117V52.0144C37.5933 56.1717 34.1838 59.5556 30.0943 59.5556Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
    <path
      d="M30.0943 59.0556C26.1784 59.0556 23.0055 55.8928 23.0055 52.0144V7.54117C23.0055 3.66275 26.1784 0.5 30.0943 0.5C33.9069 0.5 37.0933 3.65931 37.0933 7.54117V52.0144C37.0933 55.8963 33.9069 59.0556 30.0943 59.0556Z"
      stroke={colors["--icon"] || "#363435"}
      strokeOpacity="0.2"
    />
    <path
      d="M0.108765 29.7739C0.108765 25.6166 3.51827 22.2327 7.60767 22.2327H52.5011C56.6905 22.2327 60 25.6166 60 29.7739C60 33.9312 56.6905 37.315 52.5011 37.315H7.60767C3.51827 37.315 0.108765 33.9312 0.108765 29.7739Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
    <path
      d="M0.608765 29.7739C0.608765 25.892 3.79513 22.7327 7.60767 22.7327H52.5011C56.4093 22.7327 59.5 25.8877 59.5 29.7739C59.5 33.6601 56.4093 36.815 52.5011 36.815H7.60767C3.79512 36.815 0.608765 33.6557 0.608765 29.7739Z"
      stroke={colors["--icon"] || "#363435"}
      strokeOpacity="0.2"
    />
  </svg>
);
export const SecondCross = (props) => (
  <svg
    width={props.size || 50}
    height={props.size || 50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M24.9951 50C21.5051 50 18.6641 47.159 18.6641 43.669V6.33099C18.6641 2.84099 21.5051 0 24.9951 0C28.4041 0 31.2451 2.84099 31.2451 6.33099V43.669C31.2451 47.159 28.4041 50 24.9951 50Z"
      fill={props.color || "#363435"}
      fillOpacity="0.1"
    />
    <path
      d="M0 24.999C0 21.509 2.841 18.668 6.25 18.668H43.669C47.159 18.668 49.919 21.509 49.919 24.999C49.919 28.49 47.159 31.33 43.669 31.33H6.25C2.841 31.33 0 28.49 0 24.999Z"
      fill={props.color || "#363435"}
      fillOpacity="0.1"
    />
  </svg>
);
export const FilledStar = (props) => (
  <svg
    width={props.size || 83}
    height={props.size || 83}
    viewBox="0 0 83 83"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_244)">
      <path
        d="M82.8258 41.4129C48.4756 45.2652 45.2653 48.4755 41.4129 82.8257C37.5606 48.4755 34.3502 45.2652 0 41.4129C34.3502 37.5605 37.5606 34.3502 41.4129 0C45.2653 34.3502 48.4756 37.5605 82.8258 41.4129Z"
        fill={props?.color || "#BED643"}
      />
    </g>
    <defs>
      <clipPath id="clip0_1_244">
        <rect width={83} height={83} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const BlogCross = (props) => (
  <svg
    width={61}
    height={61}
    viewBox="0 0 61 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M30.5 60.1211C26.31 60.1211 22.9 56.712 22.9 52.5237V7.71854C22.9 3.53023 26.31 0.121094 30.5 0.121094C34.59 0.121094 38 3.53023 38 7.71854V52.5237C38 56.712 34.59 60.1211 30.5 60.1211Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
    <path
      d="M0.48999 30.1209C0.48999 25.9326 3.89999 22.5234 7.98999 22.5234H52.89C57.08 22.5234 60.39 25.9326 60.39 30.1209C60.39 34.3092 57.08 37.7183 52.89 37.7183H7.98999C3.89999 37.7183 0.48999 34.3092 0.48999 30.1209Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
  </svg>
);
export const TestBgStar = (props) => (
  <svg
    width={props.size || 50}
    height={props.size || 50}
    className={props.className}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.127 22.886C40.988 23.64 44.545 24.174 49 24.703C44.544 25.233 40.987 25.775 38.127 26.54C34.847 27.416 32.463 28.589 30.683 30.387C28.902 32.185 27.747 34.586 26.883 37.877C26.13 40.748 25.596 44.313 25.067 48.77C24.537 44.313 23.994 40.747 23.23 37.876C22.354 34.584 21.182 32.183 19.384 30.386C17.587 28.588 15.186 27.416 11.894 26.54C9.023 25.775 5.458 25.233 1 24.703C5.457 24.174 9.02201 23.64 11.893 22.886C15.184 22.023 17.586 20.868 19.383 19.087C21.181 17.307 22.354 14.923 23.23 11.643C23.994 8.78301 24.537 5.22602 25.067 0.77002C25.596 5.22502 26.13 8.78201 26.883 11.643C27.747 14.921 28.902 17.306 30.683 19.087C32.464 20.868 34.849 22.023 38.127 22.886Z"
      fill="transparent"
      stroke={colors["--primary"] || "#BED643"}
    />
  </svg>
);

export const TestCross1 = (props) => (
  <svg
    width={50}
    height={51}
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M25.003 50.77C21.513 50.77 18.672 47.9301 18.672 44.4401V7.09998C18.672 3.60998 21.513 0.77002 25.003 0.77002C28.412 0.77002 31.253 3.60998 31.253 7.09998V44.4401C31.253 47.9301 28.412 50.77 25.003 50.77Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
    <path
      d="M0 25.7699C0 22.2799 2.841 19.4399 6.25 19.4399H43.669C47.159 19.4399 49.919 22.2799 49.919 25.7699C49.919 29.2599 47.159 32.0999 43.669 32.0999H6.25C2.841 32.0999 0 29.2599 0 25.7699Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
  </svg>
);
export const TestBigCross = (props) => (
  <svg
    width={81}
    height={81}
    viewBox="0 0 81 81"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M40.9399 79.8398C35.6299 79.8398 31.3101 75.5188 31.3101 70.2098V10.4698C31.3101 5.16185 35.6299 0.839844 40.9399 0.839844C46.1199 0.839844 50.4399 5.15785 50.4399 10.4698V70.2098C50.4399 75.5228 46.1199 79.8398 40.9399 79.8398Z"
      stroke={colors["--primary"] || "#BED643"}
      strokeOpacity="0.2"
    />
    <path
      d="M1.44995 40.338C1.44995 35.026 5.76995 30.708 10.95 30.708H70.8199C76.1199 30.708 80.3199 35.022 80.3199 40.338C80.3199 45.655 76.1199 49.968 70.8199 49.968H10.95C5.76995 49.968 1.44995 45.651 1.44995 40.338Z"
      stroke={colors["--primary"] || "#BED643"}
      strokeOpacity="0.2"
    />
  </svg>
);
export const AeroRight = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.61129 7.85979C1.66141 7.86792 1.71213 7.87168 1.7629 7.87102L10.405 7.87102L10.2166 7.95867C10.0324 8.04586 9.86481 8.1645 9.72137 8.30926L7.2979 10.7327C6.97873 11.0374 6.9251 11.5276 7.17081 11.8941C7.45679 12.2846 8.00522 12.3694 8.3958 12.0834C8.42736 12.0603 8.45734 12.0351 8.48553 12.008L12.8679 7.62561C13.2104 7.28351 13.2107 6.72856 12.8686 6.38607L12.8679 6.38539L8.48553 2.00298C8.14277 1.66118 7.58782 1.66195 7.246 2.00471C7.2191 2.03169 7.19398 2.06039 7.17081 2.09063C6.9251 2.45714 6.97873 2.94728 7.2979 3.25197L9.71699 5.67982C9.84558 5.80856 9.99343 5.91649 10.1552 5.99973L10.4182 6.11806L1.81113 6.11806C1.36339 6.10143 0.970558 6.4142 0.886443 6.8543C0.808957 7.33212 1.13347 7.78228 1.61129 7.85979Z"
      fill={props.color}
    />
  </svg>
);
export const HomeIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 8.69902C19.4994 8.69859 19.4989 8.69797 19.4984 8.6975L11.3401 0.539453C10.9923 0.191484 10.5299 0 10.0382 0C9.54638 0 9.08404 0.191484 8.73615 0.539414L0.581964 8.69336C0.57923 8.69609 0.576339 8.69898 0.573761 8.70176C-0.140379 9.41996 -0.139129 10.5853 0.577277 11.3017C0.904543 11.6291 1.33665 11.8187 1.79888 11.8386C1.81778 11.8405 1.83673 11.8414 1.85579 11.8414H2.18079V17.8451C2.18079 19.0333 3.14759 20 4.33579 20H7.52763C7.85126 20 8.11357 19.7375 8.11357 19.414V14.707C8.11357 14.1649 8.5547 13.7239 9.09685 13.7239H10.9795C11.5217 13.7239 11.9626 14.1649 11.9626 14.707V19.4141C11.9626 19.7375 12.2249 20 12.5485 20H15.7404C16.9287 20 17.8954 19.0334 17.8954 17.8452V11.8414H18.1969C18.6885 11.8414 19.1509 11.6499 19.4989 11.3018C20.2161 10.5844 20.2164 9.41691 19.5 8.69898L19.5 8.69902ZM18.6702 10.4733C18.6082 10.5357 18.5344 10.5852 18.4532 10.6188C18.372 10.6525 18.2848 10.6698 18.1969 10.6696H17.3094C16.9858 10.6696 16.7234 10.9318 16.7234 11.2555V17.8452C16.7234 18.3871 16.2825 18.8281 15.7403 18.8281H13.1345V14.707C13.1345 13.5188 12.1678 12.552 10.9794 12.552H9.09689C7.90853 12.552 6.94173 13.5188 6.94173 14.707V18.8281H4.33587C3.79384 18.8281 3.35271 18.3871 3.35271 17.8452V11.2555C3.35271 10.9318 3.0904 10.6695 2.76677 10.6695H1.89454C1.8854 10.6689 1.87624 10.6685 1.86708 10.6683C1.69251 10.6652 1.5288 10.596 1.40614 10.4731C1.14521 10.2122 1.14521 9.78758 1.40614 9.52648C1.40626 9.52648 1.40626 9.52633 1.40642 9.52617L1.40689 9.5257L9.56497 1.36797C9.62694 1.30559 9.70068 1.25613 9.78191 1.22247C9.86314 1.18881 9.95025 1.17161 10.0382 1.17188C10.2168 1.17188 10.3849 1.24145 10.5113 1.36797L18.6676 9.52406L18.6714 9.52773C18.931 9.78914 18.9305 10.2129 18.6702 10.4733Z"
      fill={props.color || "#131313"}
    />
  </svg>
);

export const PhoneIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_265_1986)">
      <path
        d="M23.2765 18.565C22.2215 16.3586 20.4229 14.9198 17.8328 14.2723C17.4493 14.1763 17.0416 14.2723 16.7298 14.5363L14.5955 16.2866C14.1877 16.6226 13.5882 16.6706 13.1327 16.3826C10.8784 14.9918 9.03181 13.145 7.64101 10.891C7.35301 10.4354 7.40101 9.83593 7.73701 9.42817L9.48757 7.29385C9.75133 6.98209 9.84733 6.57433 9.75133 6.19081C9.07981 3.57673 7.64101 1.77817 5.43469 0.723126C5.07493 0.555126 4.66741 0.555126 4.30765 0.747126C3.20461 1.34665 2.12533 2.01793 1.11805 2.76145C0.734526 3.04921 0.542526 3.52873 0.614526 4.00849C1.33405 8.30113 3.66013 12.8093 7.42525 16.5744C11.1904 20.3395 15.6985 22.6416 19.9912 23.3851C20.4709 23.4571 20.9504 23.2651 21.2382 22.8816C21.9872 21.8694 22.6605 20.8033 23.2525 19.692C23.4445 19.3322 23.4445 18.9247 23.2765 18.565Z"
        fill={props.color}
      />
    </g>
    <defs>
      <clipPath id="clip0_265_1986">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const Email = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0013 10.986L0.961289 4.55347C1.18981 4.15294 1.51993 3.81975 1.91834 3.58753C2.31674 3.35532 2.76935 3.23228 3.23049 3.23083H20.7687C21.2374 3.23246 21.697 3.35966 22.0998 3.5992C22.5026 3.83873 22.8338 4.18185 23.059 4.59283L12.0013 10.986ZM12.4386 12.7591C12.3047 12.8364 12.1528 12.8771 11.9982 12.8769C11.8437 12.8767 11.6919 12.8356 11.5582 12.7579L0.599609 6.37292V18.1384C0.601289 19.5907 1.77801 20.7676 3.23049 20.7691H20.7687C22.2212 20.7676 23.3979 19.5907 23.3996 18.1384V6.42163L12.4386 12.7591Z"
      fill={props?.color || colors["--icon"]}
    />
  </svg>
);
export const FooterStar = (props) => (
  <svg
    width={props.size || 79}
    height={props.size || 79}
    viewBox="0 0 79 79"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M78.505 39.1504C45.879 42.8208 43.025 45.8794 39.354 78.5047C35.684 45.8794 32.625 42.8208 0 39.1504C32.625 35.4801 35.684 32.6253 39.354 0C43.025 32.6253 45.879 35.4801 78.505 39.1504Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
  </svg>
);

export const FooterCross = (props) => (
  <svg
    width={70}
    height={70}
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M34.65 69.306C29.81 69.306 25.88 65.369 25.88 60.531V8.776C25.88 3.938 29.81 0 34.65 0C39.38 0 43.3101 3.938 43.3101 8.776V60.531C43.3101 65.369 39.38 69.306 34.65 69.306Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
    <path
      d="M0 34.6549C0 29.8169 3.94003 25.8789 8.66003 25.8789H60.53C65.37 25.8789 69.1899 29.8169 69.1899 34.6549C69.1899 39.4929 65.37 43.4309 60.53 43.4309H8.66003C3.94003 43.4309 0 39.4929 0 34.6549Z"
      fill={colors["--primary"] || "#BED643"}
      fillOpacity="0.1"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    width={10}
    height={11}
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_546_6397)">
      <path
        d="M10 1.5L9 0.5L5 4.5L1 0.5L0 1.5L4 5.5L0 9.5L1 10.5L5 6.5L9 10.5L10 9.5L6 5.5L10 1.5Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_546_6397">
        <rect
          width={10}
          height={10}
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const EyeIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92892 15.75 8.25 14.0711 8.25 12C8.25 9.92894 9.92892 8.25002 12 8.25002C14.0711 8.25002 15.75 9.92894 15.75 12Z"
      stroke={colors["--icon"] || "#363435"}
      strokeWidth="1.5"
      strokeMiterlimit={10}
    />
    <path
      d="M22.8867 12C22.8867 12 18.2132 19.5 12 19.5C5.78675 19.5 1.11328 12 1.11328 12C1.11328 12 5.78675 4.50004 12 4.50004C18.2132 4.50004 22.8867 12 22.8867 12Z"
      stroke={colors["--icon"] || "#363435"}
      strokeWidth="1.5"
      strokeMiterlimit={10}
    />
  </svg>
);
/* <------- Video-Play-Icon -------> */
export const VideoPlayIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.42773 0L18.5706 10L1.42773 20V0Z"
      fill={props?.color || "#FFFFFF"}
    />
  </svg>
);
/* <-------Folder-Icon -------> */
export const FolderIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13.5 3H7.5C7.35908 2.84245 7.18646 2.71646 6.99344 2.63029C6.80043 2.54413 6.59138 2.49972 6.38 2.5H2.5C2.10218 2.5 1.72064 2.65804 1.43934 2.93934C1.15804 3.22065 1 3.60218 1 4V12C1 12.3978 1.15804 12.7794 1.43934 13.0607C1.72064 13.342 2.10218 13.5 2.5 13.5H13.5C13.8978 13.5 14.2794 13.342 14.5607 13.0607C14.842 12.7794 15 12.3978 15 12V4.5C15 4.10218 14.842 3.72065 14.5607 3.43934C14.2794 3.15804 13.8978 3 13.5 3ZM14 4.5V4.59C13.8397 4.53179 13.6706 4.50135 13.5 4.5H8.62C8.52682 4.50065 8.43531 4.47525 8.35579 4.42665C8.27628 4.37806 8.21193 4.30822 8.17 4.225L8.06 4H13.5C13.6326 4 13.7598 4.05268 13.8536 4.14645C13.9473 4.24022 14 4.36739 14 4.5ZM14 12C14 12.1326 13.9473 12.2598 13.8536 12.3536C13.7598 12.4473 13.6326 12.5 13.5 12.5H2.5C2.36739 12.5 2.24021 12.4473 2.14645 12.3536C2.05268 12.2598 2 12.1326 2 12V4C2 3.86739 2.05268 3.74022 2.14645 3.64645C2.24021 3.55268 2.36739 3.5 2.5 3.5H6.38C6.47318 3.49935 6.56469 3.52476 6.6442 3.57335C6.72372 3.62194 6.78807 3.69178 6.83 3.775L7.275 4.67C7.39972 4.91982 7.5917 5.12988 7.82932 5.27651C8.06694 5.42315 8.34078 5.50055 8.62 5.5H13.5C13.6326 5.5 13.7598 5.55268 13.8536 5.64645C13.9473 5.74022 14 5.86739 14 6V12Z"
      fill="currentColor"
    />
  </svg>


);
export const WhatsAppIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.size || 16}
    height={props?.size || 16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
  </svg>
);